// @flow
import React, { PureComponent } from 'react';
import { View, StyleSheet, ScrollView, RefreshControl } from 'react-native';
import { Text } from 'trpc-react-native-ui';

import I18n from '../../../../lib/i18n';
import { InternationalHeader, TwoColumnsList } from '../../../../components/international';
import theme from '../../../../theme-config';
import RoamingFooter from '../RoamingFooter';

import type { CountryType } from '../../../../config/iddCountries';
import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';

class RoamLikeHome extends PureComponent<Props> {
  styles = getStyles();

  moreInformation = [
    {
      title: I18n.t('RoamingOffer.RoamingPackage.validity'),
      text: I18n.t('RoamingOffer.RoamingPackage.validityDescription'),
    },
    {
      title: I18n.t('RoamingOffer.RoamingPackage.renewal'),
      text: I18n.t('RoamingOffer.RoamingPackage.renewalDescription'),
    },
    {
      title: I18n.t('RoamingOffer.RoamingPackage.more'),
      text: I18n.t('RoamingOffer.RoamingPackage.moreDescription'),
    },
  ];

  getTextLine1 = () => {
    if (this.props.extended) {
      if (this.props.roamingCountryId) {
        return I18n.t('RoamingOffer.ExtendedRoamLikeHome.domesticPlanOutOf', {
          country: I18n.t(`countries.${this.props.roamingCountryId}`),
        });
      }
    }

    return I18n.t('RoamingOffer.RoamLikeHome.callCountries', {
      countries: this.props.countryList.map(country => country.name).join(', '),
    });
  };

  render() {
    return (
      <View style={this.styles.container}>
        <ScrollView
          refreshControl={
            <RefreshControl onRefresh={this.props.fetchRoamingBundles} refreshing={this.props.isLoading} />
          }
        >
          <InternationalHeader
            iconName="paper-plane"
            iconColor={theme.roamingIconColor}
            image={theme.roamLikeHomeOfferImage}
            imageStyle={{
              width: 85,
              height: 109,
              resizeMode: 'contain',
              marginHorizontal: 10,
            }}
            title={
              this.props.extended
                ? I18n.t('RoamingOffer.ExtendedRoamLikeHome.offerName')
                : I18n.t('RoamingOffer.RoamLikeHome.offerName')
            }
            textLine1={this.getTextLine1()}
            linkText={this.props.extended ? I18n.t('RoamingOffer.eligibleCountries') : null}
            countryList={this.props.extended ? this.props.countryList : null}
          />
          <Text style={this.styles.subtitle}>{I18n.t('RoamingOffer.RoamLikeHome.subtitle')}</Text>
          {this.moreInformation.map(info => (
            <TwoColumnsList key={info.title} title={info.title} text={info.text} />
          ))}
        </ScrollView>
        <RoamingFooter
          price={this.props.price}
          orderLabel={
            this.props.extended
              ? I18n.t('RoamingOffer.ExtendedRoamLikeHome.yourPlan')
              : I18n.t('RoamingOffer.RoamLikeHome.yourPlan')
          }
          onConfirm={this.props.buy}
          confirmText={I18n.t('RoamingOffer.RoamLikeHome.confirmButton')}
          disabled={!this.props.canBuy}
          isExemptedFromTax={this.props.isExemptedFromTax}
          isLoading={this.props.isConfirmationLoading}
        />
      </View>
    );
  }
}

export type StateProps = {
  price: number,
  canBuy: boolean,
  countryList: CountryType[],
  roamingCountryId: ?string,
  isExemptedFromTax: boolean,
  isConfirmationLoading: boolean,
};

export type DispatchProps = {
  buy: Function,
  fetchRoamingBundles: Function,
};

type Props = StateProps &
  DispatchProps & {
    extended?: boolean,
    isLoading: boolean,
    navigation: NavigationScreenProp<NavigationRoute>,
  };

function getStyles() {
  return StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'space-between',
    },
    subtitle: {
      fontSize: 16,
      padding: 17,
      paddingTop: 24,
    },
  });
}

export default RoamLikeHome;
